export default __webpack_public_path__ + "static/media/product2.ad93808f.webp";